import { IResourceComponentsProps, useShow } from "@refinedev/core";
import { Show } from "@refinedev/antd";
import { Typography, Tag } from "antd";
import { Vendor } from "./interface";
import { VENDOR_ONE_QUERY } from "./queries";

const { Title, Text } = Typography;

export const ShowVendor: React.FC<IResourceComponentsProps> = () => {
  const { queryResult } = useShow<Vendor>({
    meta: {
      gqlQuery: VENDOR_ONE_QUERY,
    },
  });
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>Company Name</Title>
      <Text>{record?.companyName}</Text>

      <Title level={5}>Is Local</Title>
      <Text>{record?.isLocal ? <Tag color="green">Yes</Tag> : <Tag color="red">No</Tag>}</Text>

      <Title level={5}>TIN</Title>
      <Text>{record?.tin || "N/A"}</Text>

      <Title level={4}>Address</Title>
      <Title level={5}>Address Line</Title>
      <Text>{record?.address?.addressLine || "N/A"}</Text>
      <Title level={5}>City</Title>
      <Text>{record?.address?.city}</Text>
      <Title level={5}>Country</Title>
      <Text>{record?.address?.country}</Text>
      <Title level={5}>Email</Title>
      <Text>{record?.address?.email || "N/A"}</Text>
      <Title level={5}>P.O. Box</Title>
      <Text>{record?.address?.pobox || "N/A"}</Text>
      <Title level={5}>Phones</Title>
      <Text>{record?.address?.phones?.join(", ") || "N/A"}</Text>

      <Title level={4}>Contact Person</Title>
      <Title level={5}>Contact Name</Title>
      <Text>{record?.contact?.name}</Text>
      <Title level={5}>Contact Address Line</Title>
      <Text>{record?.contact?.address?.addressLine || "N/A"}</Text>
      <Title level={5}>Contact City</Title>
      <Text>{record?.contact?.address?.city}</Text>
      <Title level={5}>Contact Country</Title>
      <Text>{record?.contact?.address?.country}</Text>
      <Title level={5}>Contact Email</Title>
      <Text>{record?.contact?.address?.email || "N/A"}</Text>
      <Title level={5}>Contact P.O. Box</Title>
      <Text>{record?.contact?.address?.pobox || "N/A"}</Text>
      <Title level={5}>Contact Phones</Title>
      <Text>{record?.contact?.address?.phones?.join(", ") || "N/A"}</Text>
    </Show>
  );
};